import { useState, useEffect } from "react";
import { TrendingUp, TrendingDown, BarChart3, Tag } from "lucide-react";
import { apiClient } from "../App";
import { 
  BarChart, 
  Bar, 
  XAxis, 
  YAxis, 
  Tooltip, 
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell
} from "recharts";

const buildAnalyticsFromOpportunities = (opportunities = []) => {
  const trend_distribution = {};
  const niche_distribution = {};
  const top_tags = {};

  opportunities.forEach((opp) => {
    const trend = opp?.trend_status || opp?.trend || "unknown";
    const niche = opp?.niche || "Other";
    const tags = Array.isArray(opp?.tags) ? opp.tags : [];

    trend_distribution[trend] = (trend_distribution[trend] || 0) + 1;
    niche_distribution[niche] = (niche_distribution[niche] || 0) + 1;

    tags.forEach((tag) => {
      top_tags[tag] = (top_tags[tag] || 0) + 1;
    });
  });

  return {
    trend_distribution,
    niche_distribution,
    top_tags,
  };
};

const AnalyticsPage = () => {
  return (
    <div className="px-4 py-5 md:p-8 lg:p-12">
      <div className="mb-6 md:mb-8">
        <h1 className="text-2xl md:text-4xl font-bold tracking-tight text-white mb-2" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
          Analytics
        </h1>
        <p className="text-zinc-400">Market insights and opportunity trends</p>
      </div>

      <div className="bg-[#111111] border border-[#1F1F1F] rounded-2xl md:rounded-[2rem] p-8 md:p-12 text-center">
        <BarChart3 className="w-16 h-16 text-zinc-700 mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-white mb-2" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
          Analytics coming soon
        </h2>
        <p className="text-zinc-500 max-w-md mx-auto">
          We're building powerful analytics based on your saved opportunities. This feature will be available soon.
        </p>
      </div>
    </div>
  );
};

export default AnalyticsPage;
